import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModuleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		opacity: .8,
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.002 4C6.68824 4 4.00195 6.68629 4.00195 10V22C4.00195 25.3137 6.68824 28 10.002 28H22.002C25.3157 28 28.002 25.3137 28.002 22V10C28.002 6.68629 25.3157 4 22.002 4H10.002ZM15.948 21.2931C16.57 21.2931 17.0719 20.7894 17.0719 20.1688C17.0719 19.5478 16.57 19.0445 15.948 19.0445C15.3283 19.0445 14.8242 19.5482 14.8242 20.1688C14.8242 20.7894 15.3283 21.2931 15.948 21.2931ZM12.8086 14.0977C12.8086 11.7111 14.1717 10.5 15.9836 10.5C17.7581 10.5 19.0164 11.5951 18.9953 13.3773C18.9796 14.6009 18.2353 15.4041 17.6367 16.0499C16.8014 16.9505 16.805 17.4243 16.8095 18.0123C16.8098 18.0559 16.8101 18.1001 16.8101 18.1451H15.0369C15.0369 18.0955 15.0369 18.0469 15.0368 17.9992C15.0352 16.689 15.0345 16.1153 16.3033 14.909L16.3052 14.9071C16.8103 14.4264 17.2094 14.0464 17.1542 13.2981C17.1029 12.5862 16.5079 12.2139 15.9471 12.2139C14.9946 12.2139 14.5872 13.0616 14.5872 14.0977H12.8086Z",
			fill: "white"
		})
	})
});
export { SvgModuleIcon as ReactComponent };
